import React from "react";
import moment from "moment";
import styled from "styled-components";

const PERIODS = [
  { key: "day", label: "Day", amount: 1, unit: "day" },
  { key: "week", label: "Week", amount: 1, unit: "week" },
  { key: "1month", label: "Month", amount: 1, unit: "month" },
  { key: "3month", label: "3Month", amount: 3, unit: "month" },
  { key: "1year", label: "Year", amount: 1, unit: "year" },
];

const Wrap = styled.div`
  display: flex;
  gap: 4px;
  justify-content: flex-end;
`;

const PeriodButton = styled.button`
  &&& {
    min-width: 56px;
    height: 28px;
    font-size: 12px;
    border: 1px solid #b8cbe0;
    background-color: #e5f3ff;
    color: #002c5f;
    cursor: pointer;
    border-radius: 3px;
  }
  &&&.active {
    background-color: #002c5f;
    border-color: #002c5f;
    color: #fff;
  }
`;

const PeriodQuickButtons = ({ selected, onSelect }) => {
  const handleClick = (period) => {
    const end = moment().toDate();
    // 오늘을 포함하는 기간으로 계산 (예: Week = 오늘 포함 7일)
    const start = moment()
      .subtract(period.amount, period.unit)
      .add(1, "day")
      .toDate();
    onSelect(start, end, period.key);
  };

  return (
    <Wrap>
      {PERIODS.map((period) => (
        <PeriodButton
          key={period.key}
          type="button"
          className={selected === period.key ? "active" : ""}
          onClick={() => handleClick(period)}
        >
          {period.label}
        </PeriodButton>
      ))}
    </Wrap>
  );
};

export default PeriodQuickButtons;
